// --- 1. Element Search Function ---
/**
 * Searches the document for a specific tag whose innerHTML exactly matches the target string.
 * @param {string} tagName - The type of element to search (e.g., 'H2').
 * @param {string} targetHTML - The exact innerHTML content to match.
 * @returns {HTMLElement | null} The matching element or null if not found.
 */
function getElementByInnerHTML(tagName, targetHTML) {
    const elements = document.getElementsByTagName(tagName.toUpperCase());
    for (let i = 0; i < elements.length; i++) {
        // Use trim() to account for potential leading/trailing whitespace
        if (elements[i].innerHTML.trim() === targetHTML.trim()) {
            return elements[i];
        }
    }
    return null;
}

// --- 2. Colorization Function ---
function colorizeSpecificText(tagName, targetHTML, specificColors) {
    const textElement = getElementByInnerHTML(tagName, targetHTML);

    if (!textElement) {
        console.error(`Element with tag ${tagName} and content not found.`);
        return;
    }

    // Step 1: Get all text nodes (ignores HTML tags like <br>)
    const walker = document.createTreeWalker(
        textElement,
        NodeFilter.SHOW_TEXT,
        null,
        false
    );

    const textNodes = [];
    let node;
    while (node = walker.nextNode()) {
        textNodes.push(node);
    }

    // Step 2: Split each text node into words and wrap in spans
    let colorIndex = 0;
    textNodes.forEach(textNode => {
        const words = textNode.nodeValue.trim().split(/\s+/).filter(w => w);
        if (!words.length) return;

        const fragment = document.createDocumentFragment();
        words.forEach((word, i) => {
            const span = document.createElement('span');
            const color = specificColors[colorIndex % specificColors.length];
            span.style.color = color;
            span.textContent = word;
            fragment.appendChild(span);

            // Add space after word (except last in node)
            if (i < words.length - 1) {
                fragment.appendChild(document.createTextNode(' '));
            }

            colorIndex++;
        });

        // Replace the original text node with colored spans
        textNode.parentNode.insertBefore(fragment, textNode);
        textNode.parentNode.removeChild(textNode);
    });

    console.log("Text colorized with <br> preserved!");
}

// --- 3. Setup and Execution (Run this in the console) ---
const specificColors = [
    'rgba(38, 116, 203, 1)',      // for "This"
    'rgba(237, 88, 64, 1)',     // for "book"
    'rgba(97, 75, 156, 1)',  // for "is"
    'rgba(236, 0, 140, 1)',   // for "for"
    'rgba(38, 116, 203, 1)',   // for "you!"
];
const specificColors2 = [
    'rgba(38,116,203,1)',    //what  
    'rgba(237, 88, 64, 1)',     //parents
    'rgba(97,75,156,1)',        //like
    'rgba(236,0,140,1)',    //you
    'rgba(237,88,64,1)',   // are
    'rgba(38,116,203,1)',   // saying
];
const specificColors3 = [
    'rgba(255, 255, 255, 1)',    //if 
    'rgba(255, 255, 255, 1)',    //this
    'rgba(38, 116, 203, 1)',    //sounds 
    'rgba(237,88,64,1)',     //familiar
        'rgba(255, 255, 255, 1)',    //youre
    'rgba(255, 255, 255, 1)',    //in
    'rgba(255, 255, 255, 1)',    //the
    'rgba(236,0,140,1)',    //right
    'rgba(97,75,156,1)', //place
    
];

// Execute the combined function, searching for an 'H2' with the specific content
colorizeSpecificText('H2', 'This Book Is For You!', specificColors);
colorizeSpecificText('H2', 'What Parents Like You Are Saying...', specificColors2);
colorizeSpecificText(
  'H2',
  `If this sounds familiar,<br>you\'re in the right place`,
  specificColors3
);